import { render, staticRenderFns } from "./ESGScopeConversionPageTemp.vue?vue&type=template&id=113abecc"
import script from "./ESGScopeConversionPageTemp.vue?vue&type=script&lang=js"
export * from "./ESGScopeConversionPageTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports